export default __webpack_public_path__ + "static/media/menu27.fbf9d50c.svg";